var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5V15C1 15.55 1.45 16 2 16H11C11.55 16 12 15.55 12 15V5H1ZM4 14H3V7H4V14ZM6 14H5V7H6V14ZM8 14H7V7H8V14ZM10 14H9V7H10V14ZM12.25 2H9V0.75C8.99921 0.551331 8.91994 0.361024 8.77946 0.220543C8.63898 0.0800612 8.44867 0.000789946 8.25 0L4.75 0C4.55133 0.000789946 4.36102 0.0800612 4.22054 0.220543C4.08006 0.361024 4.00079 0.551331 4 0.75V2H0.75C0.551088 2 0.360322 2.07902 0.21967 2.21967C0.0790177 2.36032 0 2.55109 0 2.75V4H13V2.75C13 2.55109 12.921 2.36032 12.7803 2.21967C12.6397 2.07902 12.4489 2 12.25 2ZM8 2H5V1.013H8V2Z",
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/BinIcon.f6757c0e0fad84fd837ad7d1cd486bc4.svg";
export { ForwardRef as ReactComponent };